module.exports = __webpack_public_path__ + "img/404.68e0dd99.svg";